<template>
  <el-drawer :visible.sync="drawerVisible"
             :wrapperClosable="false"
             size="75%">
    <template #title>
      <span>抽屉表格</span>
    </template>
    <div class="wrapper">
      <div class="row optional"></div>
      <div class="row table">
        <el-table :data="tableData">
          <!-- <el-table-column prop="imgName" label="名称"> </el-table-column> -->
          <el-table-column prop="cname"
                           label="员工姓名"
                           hidden="180"
                           header-align="center"
                           align="center"
                           width="100">
          </el-table-column>
          <el-table-column prop="tel"
                           label="手机号码"
                           header-align="center"
                           align="center">
          </el-table-column>
          <el-table-column prop="identityCard"
                           label="身份证"
                           align="center">
          </el-table-column>
          <el-table-column prop="workDate"
                           label="工作天数"
                           width="100"
                           align="center">
          </el-table-column>
          <el-table-column label="直接上级"
                           header-align="center">
            <el-table-column prop="directName"
                             label="经纪人"
                             align="center"
                             width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.directId == onerow.userId"
                      style="color: red">{{ scope.row.directName }}</span>
                <span v-else>{{ scope.row.directName }}</span>
              </template>
            </el-table-column>
            <el-table-column width="100"
                             prop="directBonusMoney"
                             label="奖金金额"
                             header-align="center"
                             align="right">
              <template slot-scope="scope">
                {{
                  scope.row.directBonusMoney == 0
                    ? "-"
                    : scope.row.directBonusMoney
                }}
              </template>
            </el-table-column>
            <el-table-column width="100"
                             prop="directSubsidy"
                             label="补贴金额"
                             header-align="center"
                             align="right">
              <template slot-scope="scope">
                {{
                  scope.row.directSubsidy == 0 ? "-" : scope.row.directSubsidy
                }}
              </template>
            </el-table-column>
            <el-table-column prop="directTotalMoney"
                             header-align="center"
                             align="right"
                             label="合计金额"
                             width="100">
              <template slot-scope="scope">
                {{
                  scope.row.directTotalMoney == 0
                    ? "-"
                    : scope.row.directTotalMoney
                }}
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column label="间接上级"
                           header-align="center">
            <el-table-column prop="inDirectName"
                             label="经纪人"
                             align="center"
                             width="100">
              <template slot-scope="scope">
                <span v-if="scope.row.inDirectId == onerow.userId"
                      style="color: red">{{ scope.row.inDirectName }}</span>
                <span v-else>{{ scope.row.inDirectName }}</span>
              </template>
            </el-table-column>
            <el-table-column width="100"
                             prop="inDirectBonusMoney"
                             label="奖金金额"
                             header-align="center"
                             align="right">
              <template slot-scope="scope">
                {{
                  scope.row.inDirectBonusMoney == 0
                    ? "-"
                    : scope.row.inDirectBonusMoney
                }}
              </template>
            </el-table-column>
            <el-table-column width="100"
                             prop="inDirectSubsidy"
                             label="补贴金额"
                             header-align="center"
                             align="right">
              <template slot-scope="scope">
                {{
                  scope.row.inDirectSubsidy == 0
                    ? "-"
                    : scope.row.inDirectSubsidy
                }}
              </template>
            </el-table-column>
            <el-table-column prop="inDirectTotalMoney"
                             label="合计金额"
                             width="100"
                             header-align="center"
                             align="right">
              <template slot-scope="scope">
                {{
                  scope.row.inDirectTotalMoney == 0
                    ? "-"
                    : scope.row.inDirectTotalMoney
                }}
              </template>
            </el-table-column>
          </el-table-column>
        </el-table>
        <!-- <el-pagination
          layout="total, prev, pager, next"
          :total="total"
          :page-size="10"
          :current-page.sync="currentPage"
          @current-change="handleCurrentChange"
        >
        </el-pagination> -->
      </div>
    </div>
  </el-drawer>
</template>

<script>
import { addImage, getImages } from "@/request/api/customer";

export default {
  props: {
    visible: {
      default: false,
      type: Boolean,
      require: true,
    },
    row: {
      default: () => {
        return {};
      },
      type: null,
      require: true,
    },
    onerow: {
      type: null,
    },
  },
  data () {
    return {
      drawerVisible: false,
      form: {
        img: [],
      },
      dialogVisible: false,
      loading: false,
      tableData: [],
      currentPage: 1,
      isHideUpload: false,
      chooseFactoryId: "",
      total: 0,
      rules: {
        img: [{ required: true, message: "请上传图片", trigger: "blur" }],
      },
    };
  },
  methods: {
    cancel () {
      this.form.img = [];
      this.isHideUpload = false;
    },
  },
  watch: {
    visible (newVal) {
      this.drawerVisible = newVal;
      console.log(this.row);
      this.tableData = this.row;
      // this.total = this.row.data.count;

      // const sendData = {
      //   customerId: this.row.id,
      //   pageIndex: 1,
      //   pageSize: 10,
      //   keyWord: "",
      // };
      this.chooseFactoryId = this.row.id;

      if (newVal) {
        // this.loading = true;
        this.loading = false;

        // this.$api.customer.getImages(sendData).then((res) => {
        //   if (!res.error) {
        //   
        //     this.loading = false;
        //     this.tableData = res.data.data;
        //     this.total = res.data.count;
        //   }
        // });
      }
    },
    drawerVisible (newVal) {
      this.$emit("update:visible", newVal);
    },
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  padding: 10px 20px;
}
button.btn {
  background: #0080ff;
  border: 0px;
  color: #fff;
  padding: 5px 10px;
  margin-right: 10px;
}
button.btn:hover {
  background: #004f9e;
  cursor: pointer;
}
.number-footer {
  width: 100px;
}
.myimg {
  width: 200px;
  height: auto;
}
</style>
